import type { DocumentRepository } from "../repositories/document-repository"

export const makeGetDocumentById = (repo: DocumentRepository) =>
  (id: string) => repo.getById(id)
